import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import Box from "@material-ui/core/Box";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import AddIcon from "@material-ui/icons/Add";

import AddEditAdmForm from "./AddEditAdmForm";
import ComponentLoader from "../loader/ComponentLoader";
import AdmCard from "./AdmCard";

import { ADM_AREAS_CHILD_LIST_URL } from "../../config";
import { showErrorAlert } from "../../store/actions/alerts";

import makeApiRequest from "../../utils/axios/new-axios";
import { permissions, types, checkAcl } from "../../utils/acl";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  fab: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

export default function SubAdmAreas({
  level,
  parentId,
  countryCode,
  admType,
  hasChild,
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const EDIT_ACCESS = checkAcl({ p: permissions.ADMINISTRATIVE_AREA_MANAGEMENT, t: types.VIEW_AND_EDIT });

  const [admList, setAdmList] = useState([]);
  const [isLoadingAdm, setIsLoadingAdm] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  const [values] = useState({
    //id: 0,  -- to be provided in the edit
    parentId: parentId,
    type: level,
    countryCode: countryCode,
    name: "",
    nameAlt: "",
    nameLocal: "",
    hasChild: 0,
    lat: "",
    lng: "",
    caption: "",
    description: "",
    link: "",
    meta: {
      title: "",
      description: ""
    },
    googlePlaceId: "",
    status: 0,
  });

  function handleOpenAddModal() {
    setOpenAddModal(true);
  }

  function handleCloseAddModal() {
    setOpenAddModal(false);
  }

  async function fetchAdmList(admId) {
    try {
      setIsLoadingAdm(true);
      setAdmList([]);
      const response = await makeApiRequest({
        url: `${ADM_AREAS_CHILD_LIST_URL.url}/${admId}`,
        method: ADM_AREAS_CHILD_LIST_URL.method,
      });
      setAdmList(response.data);
      setIsLoadingAdm(false);
    } catch (error) {
      setIsLoadingAdm(false);
      dispatch(
        showErrorAlert(
          "Adm List Fetch Error : " +
          (!!error.response
            ? `${error.response.status}! - ${error.response.data.errorMessage}`
            : error.message)
        )
      );
    }
  }

  useEffect(() => {
    if ((admType === 0 || admType === 1) && hasChild === 1) {
      fetchAdmList(parentId);
    }
    return () => {
      // axiosInstance.cancel("Component unmounted.");
    };
    // eslint-disable-next-line
  }, []); // [] is required to make sure that it runs only once

  return (
    <Fragment>
      <Accordion expanded>
        <AccordionSummary
          aria-controls="sub-adm-content"
          id="sub-adm-header"
        >
          <Typography className={classes.heading}>
            Sub Administrative Level - {level}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {EDIT_ACCESS &&
            <Fab
              size="small"
              color="primary"
              aria-label="add"
              className={classes.fab}
              onClick={handleOpenAddModal}
            >
              <AddIcon />
            </Fab>}
          <Box component="span" display="block" width="100%">
            <ComponentLoader isLoading={isLoadingAdm} />
            <Box
              display="flex"
              flexDirection="row"
              flexWrap="wrap"
              justifyContent="flex-start"
            >
              {admList.length > 0 ? (
                admList.map((adm) => {
                  return (
                    <AdmCard
                      key={adm.admId}
                      name={adm.name}
                      admId={adm.admId}
                      mediaId={adm.mediaId}
                      locationCount={adm.locationCount}
                      status={adm.status}
                    />
                  );
                })
              ) : !isLoadingAdm ? (
                <Box justifyContent="center" display="flex">
                  No Sub Administrative Areas !!
                </Box>
              ) : null}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      {EDIT_ACCESS &&
        <AddEditAdmForm
          action="add"
          openModal={openAddModal}
          handleCloseModal={handleCloseAddModal}
          initialValues={values}
          level={level}
        />}
    </Fragment>
  );
}
